import './scss/global/main.scss';

// importing dynamic templates for navbar and footer
import { triggerNavbarLogic } from './app/navbar';
import { renderFooter } from './app/footer';
import { accordionFunc } from './app/accordion';
import { pageTransition } from './app/page-transition';
import { triggerSwiper } from './app/swiper';
import { redirectToServicesPage } from './app/products/app';
import { showAboutInfo } from './app/about-modal';
import { renderBlogArticles } from './app/blog';
import { renderAndReadBlog } from './app/render-blog';
import { triggerForm } from './app/submit-form';
import { triggerCarousel } from './app/carousel';

triggerNavbarLogic();
renderFooter();
accordionFunc();
pageTransition();
triggerSwiper();
redirectToServicesPage();
showAboutInfo();
renderBlogArticles();
renderAndReadBlog();
triggerForm();

triggerCarousel();
